export class CommentModel {

    constructor(readonly eventCode: string,
                readonly key: string,
                readonly content: string,
                readonly authorId: string,
                readonly creationDate: Date) {
    }

}


// WEBPACK FOOTER //
// ./src/app/models/comment-model.ts